function convertPhoneNumber(phoneNumber) {
  const cleaned = phoneNumber.toString(); // Ensure it's a string
  const countryCode = cleaned.slice(0, 3); // First 3 digits
  const firstPart = cleaned.slice(3, 7); // Next 4 digits
  const secondPart = cleaned.slice(7); // Remaining digits

  return `+${countryCode} ${firstPart} ${secondPart}`;
}

export default convertPhoneNumber;
